import { NavLink } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { UserAvatar } from "@/components/UserAvatar";

export const Brand = ({ roleLabel }) => (
  <div className="flex items-center gap-3">
    <img src="/img/logo-icon.png" alt="Warrant Whizz" className="h-10 w-10 shrink-0 object-contain" data-testid="brand-logo-icon" />
    <div>
      <p className="font-display text-base font-extrabold leading-tight text-white">Warrant Whizz</p>
      <p className="font-data text-[10px] uppercase tracking-[0.2em] text-blue-300">{roleLabel}</p>
    </div>
  </div>
);

export const SidebarShell = ({ roleLabel, children, onNavigate }) => {
  const { profile, signOut } = useAuth();
  const profilePath = profile?.role === "manager" ? "/manager/profile" : "/jobs/profile";
  return (
    <div className="flex h-full flex-col bg-slate-900 px-4 py-6 text-slate-100">
      <div className="px-2">
        <Brand roleLabel={roleLabel} />
      </div>
      <div className="mt-8 flex-1">{children}</div>
      <div className="border-t border-slate-800 pt-4">
        <NavLink to={profilePath} onClick={onNavigate} data-testid="sidebar-profile-link" title="Edit profile"
          className={({ isActive }) => `group flex items-center gap-3 rounded-lg px-2 py-2 transition-colors ${isActive ? "bg-blue-900" : "hover:bg-slate-800"}`}>
          <UserAvatar userId={profile?.id} stamp={profile?.avatar_updated_at} name={profile?.full_name} className="h-8 w-8 group-hover:bg-blue-700 group-hover:text-white" testId="sidebar-avatar" />
          <span className="min-w-0">
            <span className="block truncate text-sm font-semibold text-white" data-testid="sidebar-user-name">{profile?.full_name || profile?.email}</span>
            <span className="block truncate text-xs text-slate-400">Edit profile</span>
          </span>
        </NavLink>
        <button
          onClick={signOut}
          data-testid="sidebar-signout-button"
          className="mt-1 flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-slate-300 transition-colors hover:bg-slate-800 hover:text-white"
        >
          <LogOut className="h-4 w-4" /> Sign out
        </button>
      </div>
    </div>
  );
};
